import { useEffect, useState } from 'react'
import s from './SiteHeader.module.css'

/* href가 '#'로 시작하고 '/'가 없으면 랜딩 안 앵커, '#/'면 별도 페이지 */
export const NAV = [
  { label: '홈', href: '#/' },
  { label: 'AI 에이전트 소개', href: '#/agents' },
  { label: '플랜', href: '#/plans' },
  { label: '자주 묻는 질문', href: '#/faq' },
]

export default function SiteHeader({ current }: { current?: string }) {
  const [open, setOpen] = useState(false)

  // 같은 페이지 안 앵커로 이동해도 메뉴는 닫혀야 한다
  useEffect(() => {
    const close = () => setOpen(false)
    window.addEventListener('hashchange', close)
    return () => window.removeEventListener('hashchange', close)
  }, [])

  return (
    <header className={s.header}>
      <div className={`${s.wrap} ${s.hrow}`}>
        <a className={s.logo} href="#/">
          <img className={s.mark} src="/assets/logo-mark.png" alt="AI 오토팀 로고" />
          AI 오토팀
        </a>

        <nav id="site-nav" className={open ? s.open : undefined} onClick={() => setOpen(false)}>
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className={n.href === (current ?? '#/') ? s.on : undefined}
            >
              {n.label}
            </a>
          ))}
          {/* 좁은 화면에서는 헤더의 가입 버튼이 빠지므로 메뉴 안에 둔다 */}
          <a className={`${s.btn} ${s.btnPrimary} ${s.navCta}`} href="#/signup">
            무료로 시작하기
          </a>
        </nav>

        <div className={s.hact}>
          <a className={`${s.btn} ${s.btnGhost}`} href="#/login">
            로그인
          </a>
          <a className={`${s.btn} ${s.btnPrimary}`} href="#/signup">
            무료로 시작하기
          </a>
        </div>

        <button
          className={s.burger}
          type="button"
          aria-label={open ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((v) => !v)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            {open ? (
              <path d="M6 6l12 12M18 6L6 18" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>
      </div>
    </header>
  )
}
